export default __webpack_public_path__ + "static/media/rooberttrial-light-webfont.a254c385.woff";